export const REQUEST_SHOW_LOADER = "loader/REQUEST_SHOW_LOADER";
export const REQUEST_HIDE_LOADER = "loader/REQUEST_HIDE_LOADER";

export const REQUEST_FAILED = "REQUEST_FAILED";
export const HANDLE_TOAST_OPEN_CLOSE="HANDLE_TOAST_OPEN_CLOSE";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const SHOW_INTERNET_TOAST="SHOW_INTERNET_TOAST";

export const SAVE_ACTIVITY_INDICATOR = "SAVE_ACTIVITY_INDICATOR";